const majorVersion = (version) => {
  const match = String(version || "").trim().match(/^v?(\d+)(?:\.|$)/i);
  return match ? Number(match[1]) : null;
};

export const isCriticalVersionUpgrade = (currentVersion, availableVersion) => {
  const currentMajor = majorVersion(currentVersion);
  const availableMajor = majorVersion(availableVersion);

  return currentMajor !== null &&
    availableMajor !== null &&
    availableMajor > currentMajor;
};
